<div class="flex-col card">
  <p>Базис: {{ shipmentBasisName }}</p>
  <p>Источник: {{ source }}</p>
  <prlw-number-input-ui
    label="Цена:"
    [minValue]="1"
    [currentValue]="price"
    [maxValue]="99999"
    (setValue)="this.eventPrice.emit($event)"
  ></prlw-number-input-ui>
  <div *ngIf="deliveryMethod">Способ доставки: {{ deliveryMethod }}</div>
  <div
    class="prevent-select change-similar-products"
    (click)="
      this.eventChangeChangeSimilarProductsTariff.emit(
        !changeSimilarProductsTariff
      )
    "
  >
    <input type="checkbox" [checked]="changeSimilarProductsTariff" />
    Изменить тариф на все продукты
  </div>
  <button *ngIf="isTraderTariff" (click)="this.eventDelete.emit()">
    Удалить
  </button>
</div>
